import React, {
  createContext, useContext, useMemo,
} from 'react';

import configurator from 'bookingbug-configurator-js';


const ConfiguratorContext = createContext({});

export const ConfiguratorProvider = ({ children }) => {
  const config = useMemo(() => {
    const output = {};
    const schemaFiles = require.context('../', true, /\.schema\.json$/);
    schemaFiles.keys().forEach((file) => {
      configurator.newSchema(schemaFiles(file));
    });

    const configFiles = require.context('../', true, /\.config\.js(on)?$/);
    configFiles.keys().forEach((file) => {
      const module = configFiles(file);
      const content = module.default || module;
      const name = Object.keys(content)[0];
      configurator.loadDefault(content);
      output[name] = configurator.getConfig(name);
    });

    return output;
  }, []);


  return (
    <ConfiguratorContext.Provider value={config}>
      { children }
    </ConfiguratorContext.Provider>
  );
};

export const useConfig = (func) => {
  const context = useContext(ConfiguratorContext);
  return typeof func === 'function' ? func(context) : context;
};
